//tasks-day-blackout-section.tsx

import { Box, Typography } from "@mui/material";
import TaskGrid from "../task-grid";
import { BlackoutTaskRow } from "../../types/task-rows";
import { Tasks } from "../../models/tasks";

interface TasksDayBlackoutSectionProps {
  rows: BlackoutTaskRow[];
  blackoutColumns: any;
  blackoutColumnOptions: any;
  periodTasksTag?: number;
  periodTasks: Tasks[];
  title: string;
}

export default function TasksDayBlackoutSection({
  rows,
  blackoutColumns,
  blackoutColumnOptions,
  periodTasksTag,
  periodTasks,
  title,
}: TasksDayBlackoutSectionProps) {
  // Same tray calculation as TasksPage
  const trayTotal = periodTasks[0].blackout.reduce(
    (sum, t) => sum + t.trays,
    0,
  );

  return (
    <Box>
      {/* ----- HEADER (identical to original TasksPage) ----- */}
      <Typography
        variant="h4"
        color="primary"
        sx={{
          pt: 4,
          display: "flex",
          alignItems: "end",
          justifyContent: "space-between",
        }}
      >
        {title}{" "}
        {trayTotal > 0 && (
          <Typography sx={{ float: "right" }} color="black" variant="body1">
            <strong>Trays to Move to Blackout Total: {trayTotal}</strong>
          </Typography>
        )}
      </Typography>

      {/* ----- GRID ----- */}
      <TaskGrid
        key={periodTasksTag}
        taskKey="blackout"
        rows={rows}
        baseColumns={blackoutColumns}
        columnOptions={blackoutColumnOptions}
        rowClassName={(params) => {
          const batch = params.row.batchClass;
          return batch ? batch : "";
        }}
      />
    </Box>
  );
}
